import { render, staticRenderFns } from "./MembersTransferApprovalStatusList.vue?vue&type=template&id=364c2406"
import script from "./MembersTransferApprovalStatusList.vue?vue&type=script&lang=js"
export * from "./MembersTransferApprovalStatusList.vue?vue&type=script&lang=js"
import style0 from "./MembersTransferApprovalStatusList.vue?vue&type=style&index=0&id=364c2406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports